export const BACK_OPTION_VALUE = '__back__';
export const DEVELOPMENT_MANAGER_FIELD_VALUE = 'developmentManager';
export const PLACEHOLDER_TEXT = 'Please select one';

export const DEVELOPMENT_MANAGER_TYPE_TITLES = {
    USERS: { title: 'Users', subtitle: 'Teammates at your organization who have a Northspyre account' },
    CONTACTS: { title: 'Contacts', subtitle: 'External organizations with whom you collaborate' },
    COMPANIES: { title: 'Companies', subtitle: 'Individual collaborators affiliated with external organizations' },
};
